import Swal from "sweetalert2";

const DEFAULT_MESSAGE =
  "Não foi possível recuperar o pagamento. Tente novamente.";

const ALERTS = {
  payment_expired: {
    title: "Pagamento expirado",
    icon: "error",
    confirmButtonText: "Entendi"
  },
  payment_already_paid: {
    title: "Pagamento confirmado",
    icon: "success",
    confirmButtonText: "Ver minhas consultas"
  },
  payment_not_found: {
    title: "Pagamento não encontrado",
    icon: "warning",
    confirmButtonText: "Ok"
  },
  payment_unavailable: {
    title: "Pagamento indisponível",
    icon: "warning",
    confirmButtonText: "Ok"
  }
};

export function getErrorPayload(error) {
  return (error && error.response && error.response.data) || {};
}

export function getPendingPaymentAlert(error) {
  const data = getErrorPayload(error);
  const errorType = data.error_type;
  const details = (data.errors && data.errors.details) || DEFAULT_MESSAGE;
  const alert = ALERTS[errorType] || {
    title: "Pagamento",
    icon: "warning",
    confirmButtonText: "Ok"
  };

  return {
    title: alert.title,
    text: details,
    icon: alert.icon,
    confirmButtonText: alert.confirmButtonText
  };
}

export function getPaymentStatusFromErrorType(errorType) {
  const statuses = {
    payment_expired: "expired",
    payment_already_paid: "paid",
    payment_not_found: "error",
    payment_unavailable: "error"
  };

  return statuses[errorType] || "error";
}

export function getAppointmentIdFromResponse(appointmentResponse) {
  if (!appointmentResponse) {
    return null;
  }

  if (appointmentResponse.id) {
    return appointmentResponse.id;
  }

  if (
    appointmentResponse.appointments &&
    appointmentResponse.appointments.length
  ) {
    return appointmentResponse.appointments[0].id;
  }

  return null;
}

export function showPendingPaymentAlert(error) {
  return Swal.fire(getPendingPaymentAlert(error));
}
